module.exports = __webpack_public_path__ + "static/media/pay_visa_mc.e5804b27.png";